
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9 12c1.93 0 3.5-1.57 3.5-3.5S10.93 5 9 5 5.5 6.57 5.5 8.5 7.07 12 9 12zm0-5c.83 0 1.5.67 1.5 1.5S9.83 10 9 10s-1.5-.67-1.5-1.5S8.17 7 9 7zM4.77 17h4.28c-.03.16-.05.33-.05.5V19H2v-1.5C2 15.17 6.66 14 9 14c.56 0 1.25.07 1.98.2-.71.48-1.3 1.08-1.64 1.81-.055 0-.112-.003-.17-.005C9.112 16.003 9.055 16 9 16c-1.53 0-3.24.5-4.23 1zm11.73-2.5c-1.84 0-5.5 1.01-5.5 3V19h11v-1.5c0-1.99-3.66-3-5.5-3zm2.5-4c0 .94-.53 1.75-1.29 2.18-.36.2-.77.32-1.21.32-.44 0-.85-.12-1.21-.32A2.511 2.511 0 0114 10.5a2.5 2.5 0 015 0z","fill":"#1D3C6F"}})])
          )
        }
      }
    